import React, { useContext } from 'react'
import './Admin.css'
import { Outlet } from 'react-router-dom'
import { Sidebar } from '../../components/sidebar/Sidebar'
import { Context } from '../../context/Context'

const Admin = () => {
    const { lang } = useContext(Context);
    return (
        <div className={`admin ${lang==='ar'?'ar':''}`}>
            <Sidebar/>
            <Outlet/>
        </div>
    )
}

export default Admin